@if (open()) {
  <div class="comment-modal">
    <div
      #feedbackPanel
      cdkDrag
      cdkDragBoundary=".comment-modal"
      role="dialog"
      aria-modal="false"
      aria-labelledby="feedback-modal-title"
      aria-describedby="feedback-modal-description feedback-modal-note"
      aria-busy="{{ submitting() }}"
      tabindex="-1"
      class="comment-modal__panel feedback-modal"
      [class.feedback-modal--up]="feedbackType() === 'up'"
      (keydown.escape)="closed.emit()">
      <header cdkDragHandle class="comment-modal__header">
        <h3 id="feedback-modal-title" class="comment-modal__title feedback-modal__title">feedback form</h3>
        <button type="button" class="comment-modal__close" aria-label="Close" (click)="closed.emit()">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </header>

      <div class="feedback-modal__body">
      <p class="feedback-modal__section-title">About this recommendation</p>

      <p id="feedback-modal-description" class="feedback-modal__lead">
        <i
          class="pi"
          aria-hidden="true"
          [class.pi-thumbs-up-fill]="feedbackType() === 'up'"
          [class.pi-thumbs-down-fill]="feedbackType() === 'down'"></i>
        <span>
          @if (feedbackType() === 'up') {
            <strong>Tell us more about what was done correctly. The more details you give, the more the AI can learn.</strong>
          } @else {
            <strong>Tell us more about what went wrong.</strong>
          }
        </span>
      </p>

      <fieldset class="feedback-modal__options">
        <legend class="feedback-modal__check-label">Check all that apply.</legend>
        @for (reason of feedbackReasons(); track reason) {
          <label class="feedback-option">
            <input
              type="checkbox"
              class="feedback-option__input"
              [checked]="isFeedbackReasonSelected(reason)"
              [disabled]="submitting()"
              (change)="reasonToggled.emit(reason)" />
            <span class="feedback-option__text">{{ reason }}</span>
          </label>
        }
      </fieldset>

      <hr class="feedback-modal__divider" />

      <p class="feedback-modal__section-title">About this page</p>

      <label class="feedback-modal__comments-label" for="feedback-comment">Comments (optional)</label>
      <span id="feedback-modal-comments-hint" class="feedback-modal__comments-hint">
        @if (feedbackType() === 'up') {
          Anything about the page that worked well for you - layout, information, or what made it easier to use.
        } @else {
          Anything about the page that could be better - layout, missing information, or something confusing or broken.
        }
      </span>
      <textarea
        id="feedback-comment"
        class="comment-modal__textarea"
        rows="4"
        placeholder="Tell us what's working or what could be better on this page"
        [value]="feedbackComment()"
        [disabled]="submitting()"
        aria-describedby="feedback-modal-comments-hint feedback-modal-note"
        (input)="onCommentInput($event)"></textarea>

      <p id="feedback-modal-note" class="feedback-modal__note">
        Your feedback is confidential and used only to improve our services. Personal details will never be shared.
      </p>
      </div>

      @if (error()) {
        <p class="feedback-modal__error" role="alert">Couldn’t submit your feedback. Please try again.</p>
      }

      <footer class="comment-modal__actions">
        <button
          type="button"
          class="iopoc-button small secondary"
          [disabled]="submitting()"
          (click)="closed.emit()">
          cancel
        </button>
        <button
          type="button"
          class="iopoc-button small primary"
          [disabled]="submitting()"
          (click)="submitRequested.emit()">
          {{ submitting() ? 'submitting...' : 'submit' }}
        </button>
      </footer>
    </div>
  </div>
}
